import type { Task } from "~skillBuilder/utils/types";

import { title } from "../../contentBlocks";

export const AzMrtLegal = {
  name: "Legal Framework",
  uniqueName: "az-mrt-legal",
  icon: "Lesson",
  durationTimeText: "5 min",
  steps: [
    // Step 1
    {
      nextButtonText: "Start",
      questions: [
        // Question 1.1
        {
          attribute: "az-mrt.legal/overview",
          label: "",
          answerType: {
            type: "CONTENT",
            value: "valid",
            markdown: `
${title({ text: "Legal Framework", durationTimeText: "5 min" })}

As a substitute teacher, you play a vital role in keeping students safe. Beyond supporting learning in the classroom, you also carry the legal responsibility of being a mandated reporter. This means that if you suspect abuse or neglect, you are legally required to take action. While the subject can feel difficult, understanding your legal obligation is essential to protecting children and supporting the school community.
`,
          },
        },
      ],
    },
    // Step 2
    {
      nextButtonText: "Next Lesson",
      questions: [
        // Question 2.1
        {
          attribute: "az-mrt.legal/details",
          label: "Arizona Mandated Reporter Law",
          answerType: {
            type: "CONTENT",
            value: "valid",
            markdown: `

A.R.S. § 13-3620 requires teachers, school staff, and other professionals who work with children to report suspected abuse or neglect.

If you have a reasonable belief that a child is being abused or neglected, you must report immediately.

**Reports must be made directly to:**
<ul style="margin-left: 16px;">
<li>Arizona Department of Child Safety (DCS) Hotline: 1-888-SOS-CHILD (1-888-767-2445), OR</li>
<li>Local law enforcement (or tribal law enforcement if applicable).</li>
</ul>

**Key Points:**
<ul style="margin-left: 16px;">
<li>📜 <strong>Law:</strong> A.R.S. § 13-3620</li>
<li>🤔 <strong>Standard:</strong> "Reasonable belief" — no proof required</li>
<li>⏱ <strong>Immediate Reporting Required</strong> — without delay</li>
<li>☎ <strong>Where to Report:</strong> DCS Hotline or police</li>
<li>⚖ <strong>Penalties for failure to report:</strong>
  <ul style="margin-left: 16px;">
  <li>Class 1 misdemeanor for failure to report</li>
  <li>Class 6 felony if failure to report involves certain "reportable offenses" (e.g., sexual offenses against minors)</li>
  </ul>
</li>
</ul>
`,
          },
        },
      ],
    },
  ],
} as const satisfies Task;
